/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Add_RowInputs */

const en_statement_taxonomy_editor_add_row = /** @type {(inputs: Statement_Taxonomy_Editor_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add row`)
};

const nl_statement_taxonomy_editor_add_row = /** @type {(inputs: Statement_Taxonomy_Editor_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regel toevoegen`)
};

/**
* | output |
* | --- |
* | "Add row" |
*
* @param {Statement_Taxonomy_Editor_Add_RowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_add_row = /** @type {((inputs?: Statement_Taxonomy_Editor_Add_RowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Add_RowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_add_row(inputs)
	return en_statement_taxonomy_editor_add_row(inputs)
});